import { Collection } from 'modules/core/lib/mobx-rest'

import ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

enum MANUAL_EVENT_TYPES {
  created = 'created',
  updated = 'updated',
  deleted = 'deleted',
}

export class ShiftVersionHistories extends Collection<ShiftVersionHistory> {
  get cacheKey(): string {
    return 'shiftVersionHistories'
  }

  model() {
    return ShiftVersionHistory
  }

  hasManuallyEvents(shiftIds: number[]): boolean {
    const shiftIdsSet = new Set(shiftIds)

    return !!this.models.find(
      (versionHistory: ShiftVersionHistory) =>
        shiftIdsSet.has(versionHistory.attributes.shift_id) &&
        versionHistory.type in MANUAL_EVENT_TYPES
    )
  }

  hasEditedAutomaticBreak(shiftIds: number[]): boolean {
    const shiftIdsSet = new Set(shiftIds)

    return !!this.models.find(
      (versionHistory: ShiftVersionHistory) =>
        shiftIdsSet.has(versionHistory.attributes.shift_id) &&
        versionHistory.type === MANUAL_EVENT_TYPES.updated &&
        versionHistory.attributes.automatic_clock_in &&
        !versionHistory.attributes.workable
    )
  }
}
